/**
 * @desc 根据FNSKU获取对应的sku
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.mskuFacadeImpl.getSkuInfoByFnsku.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/msku/getSkuInfoByFnsku`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
